import React, { forwardRef } from 'react';

interface LayerProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const Layer = forwardRef<HTMLElement, LayerProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-layer-group ${classes}`} style={style}></i>
  );
});

Layer.displayName = 'Layer';
